var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
var generateSrc = /* @__PURE__ */ __name(function generateSrc2(baseUrl) {
  var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, key = _ref.key, width = _ref.width, height = _ref.height, extension = _ref.extension;
  var _ref2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref2$artDirectionCon = _ref2.artDirectionConfig, artDirectionConfig = _ref2$artDirectionCon === void 0 ? [] : _ref2$artDirectionCon, maxImageDimension = _ref2.maxImageDimension, _ref2$fixedBy = _ref2.fixedBy, fixedBy = _ref2$fixedBy === void 0 ? "width" : _ref2$fixedBy;
  var requestedSize = {
    width,
    height
  };
  var keyToCompare = fixedBy === "height" ? "height" : "width";
  if (maxImageDimension && requestedSize[keyToCompare] && requestedSize[keyToCompare] > maxImageDimension) {
    requestedSize[keyToCompare] = maxImageDimension;
  }
  if (artDirectionConfig && artDirectionConfig.length) {
    var oppositeKey = fixedBy === "height" ? "width" : "height";
    requestedSize = artDirectionConfig.reduce(function(acc, configItem) {
      if ((!maxImageDimension || maxImageDimension >= configItem[keyToCompare]) && requestedSize[keyToCompare] <= configItem[keyToCompare] && (acc[keyToCompare] > configItem[keyToCompare] || !acc.wasFound) && acc[oppositeKey] === configItem[oppositeKey]) {
        acc.wasFound = true;
        acc[keyToCompare] = configItem[keyToCompare];
      }
      return acc;
    }, _objectSpread(_objectSpread({}, requestedSize), {}, {
      wasFound: false
    }));
  }
  return "".concat(baseUrl, "/").concat(requestedSize.width, "x").concat(requestedSize.height, "_").concat(key, ".").concat(extension);
}, "generateSrc");
export {
  generateSrc
};
